import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalizeMonth' })
export class CapitalizeMonthPipe implements PipeTransform {
  transform(dateString: string | null): string {
    if (!dateString) return '';

    dateString = dateString.toLowerCase();

    const parts = dateString.split(' ');
    if (parts.length < 2) return dateString;

    parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1);

    return parts.join(' ');
  }
}
